import React, { Fragment, FC } from "react";
import { Popover, Transition } from "@headlessui/react";
import { UserPlusIcon } from "@heroicons/react/24/outline";
import ClearDataButton from "components/HeroSearchForm/ClearDataButton";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import { useBooking } from "context/BookingContext";
import { useClient } from "ClientContext";

import { useTranslation } from "react-i18next";

export interface GuestsInputProps {
  className?: string;
}

const GuestsInput: FC<GuestsInputProps> = ({ className = "flex-1" }) => {
  const {t}=useTranslation();
  const { bookingState, setBookingState } = useBooking(); // Get booking state and updater function
  const { searchParams } = bookingState;

  const { global_searh,setGlobal_search,global_max_guests } = useClient(); 

  const max_guests = global_max_guests > 1 ? global_max_guests : 25;

  const handleChangeData = (value: number) => {
    setBookingState((prevState) => ({
      ...prevState,
      searchParams: {
        ...prevState.searchParams,
        guests: value, 
      },
    }));
  };
  if (!max_guests) {
    return null; 
  }
  return (
    <Popover className={`flex relative ${className}`}>
      {({ open }) => (
        <>
          <div
            className={`flex-1 flex items-center focus:outline-none rounded-b-3xl ${
              open ? "shadow-lg" : ""
            }`}
          >
            <Popover.Button
              className={`relative z-10 flex-1 flex text-left items-center p-3 space-x-3 focus:outline-none`}
            >
              <div className="text-neutral-300 dark:text-neutral-400">
                <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
              </div>
              <div className="flex-grow">
                <span className="block xl:text-lg font-semibold">
                  {searchParams?.guests || 0} {t("Guests")}
                </span>
                <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                  {searchParams?.guests ? t("Guests") : t("Add guests")}
                </span>
              </div>

              {!!searchParams?.guests && open && (
                <ClearDataButton
                  onClick={() => {
                    handleChangeData(0); // Reset guests count to 0 using the update function
                  }}
                />
              )}
            </Popover.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute right-0 z-10 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl ring-1 ring-black ring-opacity-5 ">
              <NcInputNumber
                className="w-full"
                defaultValue={searchParams?.guests || 0} // Use guests count from context
                onChange={handleChangeData}
                max={max_guests}
                min={1}
                label={t("Guests")}
                desc={t("How many people?")}
              />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default GuestsInput;